import { logger } from 'utils/logger'
import isURL from 'validator/lib/isURL' // Tree-shaken import from validator package

/**
 * Only web URLs are permitted for redirects
 */
export const ALLOWED_URL_PROTOCOLS = ['http', 'https']

export interface UrlValidationResult {
  isValid: boolean
  error?: string
}

export const validateUrl = (url: string): UrlValidationResult => {
  const isValidFormat = isURL(url, {
    protocols: ALLOWED_URL_PROTOCOLS,
    require_protocol: true,
    require_host: true,
    require_valid_protocol: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_protocol_relative_urls: false,
  })

  if (!isValidFormat) {
    try {
      const parsedUrl = new URL(url)
      const protocol = parsedUrl.protocol.slice(0, -1) // Remove trailing ':'

      // Check if an unsupported protocol was used
      if (!ALLOWED_URL_PROTOCOLS.includes(protocol)) {
        logger('warn', 'CustomEmbeddedCode: Unsupported URL protocol', {
          context: { url, blockedProtocol: protocol },
        })

        return {
          isValid: false,
          error: `Dangerous or unsupported URL protocol: ${parsedUrl.protocol}`,
        }
      }
    } catch {
      logger('error', 'CustomEmbeddedCode: Error parsing URL during validation', {
        context: { url },
      })
    }

    return {
      isValid: false,
      error: 'Invalid URL format',
    }
  }

  return {
    isValid: true,
  }
}
